// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../../App.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.product-section {
  margin: 4vh 0vh;
  width: 100%;
}

.details {
  font-size: 15px;
}

.product-section .product-header {
  width: 80%;
  margin: auto;
  display: flex;
  justify-content: space-between;
  margin-bottom: 4vh;
  padding: 0 10px;
}

.product-section .product-title {
  width: 100%;
}

.product-section .product-title h2 {
  font-family: "Lexend Deca", sans-serif;
  font-size: 40px;
  color: var(--color-text-dark);
}

.product-section .product-more {
  width: auto;
  height: 100%;
}

.product-section .product-more .product-button-more {
  padding: 5px 45px;
  background-color: #ffffff;
  border-radius: 50px;
  font-size: 20px;
  font-weight: 700;
  color: #ff962e;
  border: 2px solid #ff962e;
  font-family: "Poppins", sans-serif;
  display: none;
}

.product-section .product-more .product-button-more:hover {
  background-color: #ff962e;
  color: var(--white-main);
  cursor: pointer;
}

.product-section .product-cards {
  width: 80%;
  margin: auto;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  justify-content: first baseline;
}

.product-section .product-cards .product-card {
  width: calc(90% / 5);
  height: auto;
  border: 1px solid var(--color-border-gray);
  background-color: var(--color-blue-cream);
  border-radius: 8px;
  overflow: hidden;
  margin: 14px;
  padding: 0px;
}

.product-section .product-cards .product-card .product-card-top {
  width: 100%;
  height: auto;
  background-color: var(--color-white-main);
  position: relative;
}

.product-section .product-cards .product-card .product-card-top .product-image {
  width: 14vw;
}

.product-section .product-cards .product-card .product-card-top .product-image img {
  max-width: 284px;
  height: 203px;
}

.promotion-label {
  width: 100px;
  height: 100px;
  position: absolute;
  left: 0;
  top: 0;
}

.product-section .product-cards .product-card .product-card-bottom {
  width: 100%;
  background-color: var(--color-blue-cream);
  padding: 15px;
  border-top: 1px solid var(--color-border-gray);
  display: flex;
  flex-direction: column;
  position: relative;
  height: 98px;
  display: -ms-flexbox;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -ms-flex-align: center;
  -webkit-box-align: center;
  flex-wrap: wrap;
  margin-block-start: auto;
  margin-top: auto;
}

.product-section .product-cards .product-card .product-card-bottom .category {
  font-size: 14px;
  color: var(--color-text-blue);
  font-weight: 300;
  text-align: left;
  font-family: "Lexend Deca", sans-serif;
}

.product-section .product-cards .product-card .product-card-bottom .title {
  font-size: 16px;
  color: var(--color-text-dark);
  font-weight: bolder;
  text-align: left;
  font-family: "Poppins", sans-serif;
  margin: 2px 0px;
}

.product-section .product-cards .product-card .product-card-bottom .weight {
  font-size: 14px;
  color: var(--color-text-gray);
  font-weight: 300;
  text-align: left;
  font-family: "Lexend Deca", sans-serif;
}

.product-section .product-cards .product-card .product-card-bottom .price {
  font-size: 20px;
  color: var(--color-text-blue);
  font-weight: 600;
  text-align: left;
  margin: 8px 0px;
  font-family: "Poppins", sans-serif;
}

.product-section .product-cards .product-card .product-card-bottom .card-product-buy-button {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  position: absolute;
  bottom: 1px;
  margin-top: 14px;
  flex-grow: 1;
  box-sizing: border-box;
}

.product-section .product-cards .product-card .product-card-bottom .card-product-buy-button .product-add {
  background-color: var(--color-blue-dark);
  padding: 10px 15px;
  color: var(--color-white-main);
  border: none;
  border-radius: 25px;
  font-size: 12px;
  font-family: "Poppins", sans-serif;
  font-weight: 600;
  margin-bottom: 15px;
  width: auto;
  position: absolute;
  right: 28px;
}

.product-section .product-cards .product-card .product-card-bottom .card-product-buy-button .product-add:hover {
  background-color: var(--color-blue-circle);
}

.product-section .product-cards .product-card .product-card-bottom .card-product-buy-button .product-add span {
  margin-right: 10px;
}

.product-section p {
  font-family: "Poppins", sans-serif;
  padding-left: 15px;
}

@media only screen and (min-width: 360px) and (max-width: 374px) {

  .product-section .product-cards .product-card {
    width: 79vw !important;
    height: 48vh;
    margin: auto !important;
    margin-top: 32px !important;
  }

  .product-section .product-cards .product-card .product-card-bottom {
    height: 16vh;
  }

  .product-section .product-cards .product-card .product-card-bottom .card-product-buy-button {
    bottom: 17px;
  }
}

@media only screen and (min-width: 375px) and (max-width: 389px) {

  .product-section .product-cards .product-card {
    width: 79vw !important;
    height: 41vh !important;
  }

  .product-section .product-cards .product-card .product-card-bottom {
    height: 16vh;
  }

  .product-section .product-cards .product-card .product-card-bottom .card-product-buy-button {
    bottom: 17px;
  }

  .product-section .product-cards .product-card .product-card-top .product-image img {
    max-width: 75vw;
    height: 24vh;
  }
}

@media only screen and (width: 390px) {
  .product-section .product-card {
    height: 39vh !important;
}
}

@media only screen and (min-width: 390px) and (max-width: 413px) {

  .product-section .product-cards .product-card {
    width: 79vw !important;
    height: 36vh;
  }

  .product-section .product-cards .product-card .product-card-bottom {
    height: 13vh;
  }

  .product-section .product-cards .product-card .product-card-bottom .card-product-buy-button {
    bottom: 13px;
  }

  .product-section .product-cards .product-card .product-card-top .product-image img {
    max-width: 75vw;
    height: 23vh;
  }

}

@media only screen and (min-width: 414px) and (max-width: 599px) {

  .product-section .product-cards .product-card {
    width: 318px !important;
    height: 294px;
    margin: auto !important;
  }

  .product-section .product-cards .product-card .product-card-bottom .title {
    font-size: 14px;
  }

  .product-section .product-cards .product-card .product-card-bottom {
    height: 105px;
  }

  .product-section .product-cards .product-card .product-card-bottom .card-product-buy-button {
    bottom: 1px;
  }

  .product-section .product-cards .product-card .product-card-top .product-image img {
    max-width: 315px;
    height: 188px;
  }
}

@media only screen and (min-width: 600px) and (max-width: 979px) {
  .product-header {
    width: 90%;
    padding: 0px;
  }

  .product-section .product-title h2 {
    font-size: 36px;
    text-align: center;
  }

  .product-cards {
    width: 80%;
    margin: auto;
    padding: 0px 10px;
  }

  .product-card {
    width: 100%;
    padding: 0 10px;
  }

  .product-section .product-cards .product-card .product-card-bottom {
    height: 15vh;
  }

  .product-section .product-cards .product-card .product-card-bottom .card-product-buy-button {
    top: 52px;
  }

  .product-section .product-cards .product-card {
    width: 75vw;
    height: 36vh;
    margin: 20px auto;
  }

  .product-section .product-cards .product-card .product-card-top .product-image {
    width: 74vw;
  }

  .product-section .product-cards .product-card .product-card-top .product-image img {
    max-width: 75vw;
    height: 35vh;
  }

}

@media only screen and (min-width: 980px) and (max-width: 1023px) {
  .product-section .product-cards .product-card {
    width: 18vw;
    height: 14vh;
    margin: auto;
    margin-top: 32px;
  }

  .product-section .product-cards .product-card .product-card-top {
    width: 100%;
    height: auto;
    background-color: var(--color-white-main);
    position: relative;
  }

  .product-section .product-cards .product-card .product-card-bottom .title {
    font-size: 15px;
  }

  .product-section .product-cards .product-card .product-card-bottom {
    height: 9vh;
  }

  .product-section .product-cards .product-card .product-card-bottom .card-product-buy-button {
    bottom: 57px;
  }

  .product-section .product-cards .product-card .product-card-top .product-image img {
    width: 75vw;
    max-height: 8vh;
  }
}

@media only screen and (max-width: 1024px) {
  .product-section .product-header {
    width: 90%;
    padding: 0;
  }

  .product-section {
    margin: auto;
  }

  .product-card {
    width: 33.3%;
    padding: 0 10px;
  }
}

@media only screen and (min-width: 1025px) {
  .product-card {
    width: calc(90% / 5);
    padding: 0 10px;
  }
}

@media only screen and (min-width: 1600px) {
  .product-card {
    width: 20%;
    padding: 0 10px;
  }
}

@media only screen and (max-width: 1747px) {
  .product-section .product-cards .product-card {
    width: calc(100% / 4.5);
    /* height: 310px; */
    margin: auto;
    margin-bottom: 32px !important;
  }

  .product-section .product-cards .product-card .product-card-bottom {
    height: 130px;
  }

  .product-section .product-cards .product-card .product-card-bottom .card-product-buy-button {
    bottom: 21px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/product-list/ProductList.css"],"names":[],"mappings":"AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sCAAsC;EACtC,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,kCAAkC;EAClC,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,+BAA+B;AACjC;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,0CAA0C;EAC1C,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,OAAO;EACP,MAAM;AACR;;AAEA;EACE,WAAW;EACX,yCAAyC;EACzC,aAAa;EACb,8CAA8C;EAC9C,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EAEZ,oBAAoB;EAIpB,wBAAwB;EACxB,qBAAqB;EACrB,sBAAsB;EACtB,yBAAyB;EAEzB,eAAe;EAEf,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,gBAAgB;EAChB,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,gBAAgB;EAChB,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,wCAAwC;EACxC,kBAAkB;EAClB,8BAA8B;EAC9B,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,kCAAkC;EAClC,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;;EAEE;IACE,sBAAsB;IACtB,YAAY;IACZ,uBAAuB;IACvB,2BAA2B;EAC7B;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;;EAEE;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;IACf,YAAY;EACd;AACF;;AAEA;EACE;IACE,uBAAuB;AAC3B;AACA;;AAEA;;EAEE;IACE,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;IACf,YAAY;EACd;;AAEF;;AAEA;;EAEE;IACE,uBAAuB;IACvB,aAAa;IACb,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,aAAa;EACf;AACF;;AAEA;EACE;IACE,UAAU;IACV,YAAY;EACd;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,UAAU;IACV,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;IACf,YAAY;EACd;;AAEF;;AAEA;EACE;IACE,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,yCAAyC;IACzC,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;AACF;;AAEA;EACE;IACE,UAAU;IACV,UAAU;EACZ;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;AACF;;AAEA;EACE;IACE,oBAAoB;IACpB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,UAAU;IACV,eAAe;EACjB;AACF;;AAEA;EACE;IACE,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,8BAA8B;EAChC;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;EACd;AACF","sourcesContent":["@import url(\"../../App.css\");\n\n.product-section {\n  margin: 4vh 0vh;\n  width: 100%;\n}\n\n.details {\n  font-size: 15px;\n}\n\n.product-section .product-header {\n  width: 80%;\n  margin: auto;\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 4vh;\n  padding: 0 10px;\n}\n\n.product-section .product-title {\n  width: 100%;\n}\n\n.product-section .product-title h2 {\n  font-family: \"Lexend Deca\", sans-serif;\n  font-size: 40px;\n  color: var(--color-text-dark);\n}\n\n.product-section .product-more {\n  width: auto;\n  height: 100%;\n}\n\n.product-section .product-more .product-button-more {\n  padding: 5px 45px;\n  background-color: #ffffff;\n  border-radius: 50px;\n  font-size: 20px;\n  font-weight: 700;\n  color: #ff962e;\n  border: 2px solid #ff962e;\n  font-family: \"Poppins\", sans-serif;\n  display: none;\n}\n\n.product-section .product-more .product-button-more:hover {\n  background-color: #ff962e;\n  color: var(--white-main);\n  cursor: pointer;\n}\n\n.product-section .product-cards {\n  width: 80%;\n  margin: auto;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: stretch;\n  justify-content: first baseline;\n}\n\n.product-section .product-cards .product-card {\n  width: calc(90% / 5);\n  height: auto;\n  border: 1px solid var(--color-border-gray);\n  background-color: var(--color-blue-cream);\n  border-radius: 8px;\n  overflow: hidden;\n  margin: 14px;\n  padding: 0px;\n}\n\n.product-section .product-cards .product-card .product-card-top {\n  width: 100%;\n  height: auto;\n  background-color: var(--color-white-main);\n  position: relative;\n}\n\n.product-section .product-cards .product-card .product-card-top .product-image {\n  width: 14vw;\n}\n\n.product-section .product-cards .product-card .product-card-top .product-image img {\n  max-width: 284px;\n  height: 203px;\n}\n\n.promotion-label {\n  width: 100px;\n  height: 100px;\n  position: absolute;\n  left: 0;\n  top: 0;\n}\n\n.product-section .product-cards .product-card .product-card-bottom {\n  width: 100%;\n  background-color: var(--color-blue-cream);\n  padding: 15px;\n  border-top: 1px solid var(--color-border-gray);\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  height: 98px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: row;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -ms-flex-align: center;\n  -webkit-box-align: center;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-margin-before: auto;\n  margin-block-start: auto;\n  margin-top: auto;\n}\n\n.product-section .product-cards .product-card .product-card-bottom .category {\n  font-size: 14px;\n  color: var(--color-text-blue);\n  font-weight: 300;\n  text-align: left;\n  font-family: \"Lexend Deca\", sans-serif;\n}\n\n.product-section .product-cards .product-card .product-card-bottom .title {\n  font-size: 16px;\n  color: var(--color-text-dark);\n  font-weight: bolder;\n  text-align: left;\n  font-family: \"Poppins\", sans-serif;\n  margin: 2px 0px;\n}\n\n.product-section .product-cards .product-card .product-card-bottom .weight {\n  font-size: 14px;\n  color: var(--color-text-gray);\n  font-weight: 300;\n  text-align: left;\n  font-family: \"Lexend Deca\", sans-serif;\n}\n\n.product-section .product-cards .product-card .product-card-bottom .price {\n  font-size: 20px;\n  color: var(--color-text-blue);\n  font-weight: 600;\n  text-align: left;\n  margin: 8px 0px;\n  font-family: \"Poppins\", sans-serif;\n}\n\n.product-section .product-cards .product-card .product-card-bottom .card-product-buy-button {\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  position: absolute;\n  bottom: 1px;\n  margin-top: 14px;\n  flex-grow: 1;\n  box-sizing: border-box;\n}\n\n.product-section .product-cards .product-card .product-card-bottom .card-product-buy-button .product-add {\n  background-color: var(--color-blue-dark);\n  padding: 10px 15px;\n  color: var(--color-white-main);\n  border: none;\n  border-radius: 25px;\n  font-size: 12px;\n  font-family: \"Poppins\", sans-serif;\n  font-weight: 600;\n  margin-bottom: 15px;\n  width: auto;\n  position: absolute;\n  right: 28px;\n}\n\n.product-section .product-cards .product-card .product-card-bottom .card-product-buy-button .product-add:hover {\n  background-color: var(--color-blue-circle);\n}\n\n.product-section .product-cards .product-card .product-card-bottom .card-product-buy-button .product-add span {\n  margin-right: 10px;\n}\n\n.product-section p {\n  font-family: \"Poppins\", sans-serif;\n  padding-left: 15px;\n}\n\n@media only screen and (min-width: 360px) and (max-width: 374px) {\n\n  .product-section .product-cards .product-card {\n    width: 79vw !important;\n    height: 48vh;\n    margin: auto !important;\n    margin-top: 32px !important;\n  }\n\n  .product-section .product-cards .product-card .product-card-bottom {\n    height: 16vh;\n  }\n\n  .product-section .product-cards .product-card .product-card-bottom .card-product-buy-button {\n    bottom: 17px;\n  }\n}\n\n@media only screen and (min-width: 375px) and (max-width: 389px) {\n\n  .product-section .product-cards .product-card {\n    width: 79vw !important;\n    height: 41vh !important;\n  }\n\n  .product-section .product-cards .product-card .product-card-bottom {\n    height: 16vh;\n  }\n\n  .product-section .product-cards .product-card .product-card-bottom .card-product-buy-button {\n    bottom: 17px;\n  }\n\n  .product-section .product-cards .product-card .product-card-top .product-image img {\n    max-width: 75vw;\n    height: 24vh;\n  }\n}\n\n@media only screen and (width: 390px) {\n  .product-section .product-card {\n    height: 39vh !important;\n}\n}\n\n@media only screen and (min-width: 390px) and (max-width: 413px) {\n\n  .product-section .product-cards .product-card {\n    width: 79vw !important;\n    height: 36vh;\n  }\n\n  .product-section .product-cards .product-card .product-card-bottom {\n    height: 13vh;\n  }\n\n  .product-section .product-cards .product-card .product-card-bottom .card-product-buy-button {\n    bottom: 13px;\n  }\n\n  .product-section .product-cards .product-card .product-card-top .product-image img {\n    max-width: 75vw;\n    height: 23vh;\n  }\n\n}\n\n@media only screen and (min-width: 414px) and (max-width: 599px) {\n\n  .product-section .product-cards .product-card {\n    width: 318px !important;\n    height: 294px;\n    margin: auto !important;\n  }\n\n  .product-section .product-cards .product-card .product-card-bottom .title {\n    font-size: 14px;\n  }\n\n  .product-section .product-cards .product-card .product-card-bottom {\n    height: 105px;\n  }\n\n  .product-section .product-cards .product-card .product-card-bottom .card-product-buy-button {\n    bottom: 1px;\n  }\n\n  .product-section .product-cards .product-card .product-card-top .product-image img {\n    max-width: 315px;\n    height: 188px;\n  }\n}\n\n@media only screen and (min-width: 600px) and (max-width: 979px) {\n  .product-header {\n    width: 90%;\n    padding: 0px;\n  }\n\n  .product-section .product-title h2 {\n    font-size: 36px;\n    text-align: center;\n  }\n\n  .product-cards {\n    width: 80%;\n    margin: auto;\n    padding: 0px 10px;\n  }\n\n  .product-card {\n    width: 100%;\n    padding: 0 10px;\n  }\n\n  .product-section .product-cards .product-card .product-card-bottom {\n    height: 15vh;\n  }\n\n  .product-section .product-cards .product-card .product-card-bottom .card-product-buy-button {\n    top: 52px;\n  }\n\n  .product-section .product-cards .product-card {\n    width: 75vw;\n    height: 36vh;\n    margin: 20px auto;\n  }\n\n  .product-section .product-cards .product-card .product-card-top .product-image {\n    width: 74vw;\n  }\n\n  .product-section .product-cards .product-card .product-card-top .product-image img {\n    max-width: 75vw;\n    height: 35vh;\n  }\n\n}\n\n@media only screen and (min-width: 980px) and (max-width: 1023px) {\n  .product-section .product-cards .product-card {\n    width: 18vw;\n    height: 14vh;\n    margin: auto;\n    margin-top: 32px;\n  }\n\n  .product-section .product-cards .product-card .product-card-top {\n    width: 100%;\n    height: auto;\n    background-color: var(--color-white-main);\n    position: relative;\n  }\n\n  .product-section .product-cards .product-card .product-card-bottom .title {\n    font-size: 15px;\n  }\n\n  .product-section .product-cards .product-card .product-card-bottom {\n    height: 9vh;\n  }\n\n  .product-section .product-cards .product-card .product-card-bottom .card-product-buy-button {\n    bottom: 57px;\n  }\n\n  .product-section .product-cards .product-card .product-card-top .product-image img {\n    width: 75vw;\n    max-height: 8vh;\n  }\n}\n\n@media only screen and (max-width: 1024px) {\n  .product-section .product-header {\n    width: 90%;\n    padding: 0;\n  }\n\n  .product-section {\n    margin: auto;\n  }\n\n  .product-card {\n    width: 33.3%;\n    padding: 0 10px;\n  }\n}\n\n@media only screen and (min-width: 1025px) {\n  .product-card {\n    width: calc(90% / 5);\n    padding: 0 10px;\n  }\n}\n\n@media only screen and (min-width: 1600px) {\n  .product-card {\n    width: 20%;\n    padding: 0 10px;\n  }\n}\n\n@media only screen and (max-width: 1747px) {\n  .product-section .product-cards .product-card {\n    width: calc(100% / 4.5);\n    /* height: 310px; */\n    margin: auto;\n    margin-bottom: 32px !important;\n  }\n\n  .product-section .product-cards .product-card .product-card-bottom {\n    height: 130px;\n  }\n\n  .product-section .product-cards .product-card .product-card-bottom .card-product-buy-button {\n    bottom: 21px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
